import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './stream-statuses.reducer';
import {StreamStatus} from '../../services/api/stream-statuses/stream-status.model';

export const streamStatusesFeatureKey = 'streamStatuses';
export const streamStatuesSelector = createFeatureSelector<State>(streamStatusesFeatureKey);

export const getAllStreamStatues = createSelector(
  streamStatuesSelector,
  (state: State): StreamStatus[] => state.record
);

export const getStreamStatusesLoaded = createSelector(
  streamStatuesSelector,
  (state: State): boolean => state.loaded
);

export const getStreamStatusesLoading = createSelector(
  streamStatuesSelector,
  (state: State): boolean => state.loading
);

export const getLoadStreamStatuesError = createSelector(
  streamStatuesSelector,
  (state: State): any => state.error
);
